import { WorkOrderStatus, WorkOrderTaskType } from '@xbcb/work-order-types';
import type { WorkOrderTask } from '@xbcb/api-gateway-client';
import { taskIsInProgress } from '@xbcb/work-order-utils/dist/findMostRecentInProgressTask';

const permissibleInquireWorkOrderStates = [WorkOrderStatus.IN_PROGRESS];

export const showInvoiceLineCountKebabMenuItemFunc = ({
  status,
  taskType,
  taskId,
  workOrderTasks,
}: {
  status?: WorkOrderStatus;
  taskType?: WorkOrderTaskType;
  taskId?: string;
  workOrderTasks?: WorkOrderTask[];
}): boolean => {
  const task = taskId
    ? workOrderTasks?.find((task: WorkOrderTask) => task.id === taskId)
    : workOrderTasks?.find(
        (task: WorkOrderTask) =>
          task.definition?.workOrderTaskType === taskType,
      );
  if (status && permissibleInquireWorkOrderStates.includes(status)) {
    return Boolean(task && taskIsInProgress(task));
  }

  return false;
};
